import React from "react";
const FeeReview = ({
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22",
    fill: "#FBAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 14H25.8154C25.4014 12.8383 24.3036 12.0015 23 12H21C19.6964 12.0015 18.5986 12.8383 18.1846 14H17C15.3439 14.0018 14.0018 15.3439 14 17V29C14.0018 30.6561 15.3439 31.9982 17 32H27C28.6561 31.9982 29.9982 30.6561 30 29V17C29.9982 15.3439 28.6561 14.0018 27 14ZM19 15C19.0014 13.896 19.896 13.0014 21 13H23C24.104 13.0014 24.9986 13.896 25 15V16H19V15ZM29 29C28.9986 30.104 28.104 30.9986 27 31H17C15.896 30.9986 15.0014 30.104 15 29V17C15.0014 15.896 15.896 15.0014 17 15H18V16.5C18 16.5002 18 16.5004 18 16.5006C18.0002 16.7766 18.224 17.0002 18.5 17H25.5C25.5002 17 25.5004 17 25.5006 17C25.7766 16.9998 26.0002 16.776 26 16.5V15H27C28.104 15.0014 28.9986 15.896 29 17V29ZM23.5 24H18.5C18.2239 24 18 24.2239 18 24.5C18 24.7761 18.2239 25 18.5 25H23.5C23.7761 25 24 24.7761 24 24.5C24 24.2239 23.7761 24 23.5 24ZM25.5 20H18.5C18.2239 20 18 20.2239 18 20.5C18 20.7761 18.2239 21 18.5 21H25.5C25.7761 21 26 20.7761 26 20.5C26 20.2239 25.7761 20 25.5 20Z",
    fill: "black"
  }));
};
export default FeeReview;